import { debounce } from 'lodash';
import { api, formatToIsoDate, formatToLocalDate } from '@/utils';


export default {
  name: 'GeneralDossierInfo',
  components: {},
  props: {
    inputForm: {
      type: Object,
      default: undefined,
    },
    inputFormTypes: {
      type: Array,
      default: () => [],
    },
    enums: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    type: '',
    reference: '',
    selectedCompany: null,
    sourceReference: '',
    selectedSourceCompany: null,
    source: '',
    jobDate: null,
    formFields: {
      type: {
        name: 'type',
        label: 'Type',
        validation: 'required',
      },
      reference: {
        name: 'reference',
        label: 'Reference',
        validation: 'required',
      },
      company: {
        name: 'company',
        label: 'Company',
        validation: 'required',
      },
      sourceReference: {
        name: 'sourceReference',
        label: 'Source reference',
        validation: 'required',
      },
      sourceCompany: {
        name: 'sourceCompany',
        label: 'Source company',
        validation: 'required',
      },
      source: {
        name: 'source',
        label: 'Source',
        validation: 'required',
      },
      cargoProductTypes: {
        name: 'cargoProductTypes',
        label: 'Cargo',
        validation: 'required',
      },
      jobDate: {
        name: 'jobDate',
        label: 'Job date',
        validation: 'required',
      },
    },
    // search props
    apiVersion: 1,
    pageSize: 10,
    companyEntries: [],
    searchCompany: null,
    isLoadingCompany: false,
    sourceCompanyEntries: [],
    searchSourceCompany: null,
    isLoadingSourceCompany: false,
    // searchReference
    searchReference: null,
    isLoadingReference: false,
    inputEntries: [],
    // cargoProductTypes
    cargoProductTypes: [],
  }),
  computed: {
    inputItems() {
      return this.inputEntries.map((entry) => {
        const autocompleteValue = `${entry.assigneeStakeholder.reference} - ${entry.assigneeStakeholder.name} - ${entry.inputType}`;
        return Object.assign({}, entry, { autocompleteValue });
      });
    },
    sourceDropdownValues() {
      return this.enums.length > 0 && this.enums.find(e => e.name === 'SourceType') != null ? this.enums.find(e => e.name === 'SourceType').values : [];
    },
    showCargoProductTypes() {
      const showCargoProductTypesForInputType = ['Nomination', 'ShippingAgent', 'Analysis', 'Inspection', 'Sampling'];
      return showCargoProductTypesForInputType.find(e => e === this.type) != null;
    },
  },
  methods: {
    setCompany(field, id) {
      // BASEURL
      const url = `/stakeholders/${id}`;

      api.get(url)
        .then((response) => {
          if (field === 'company') {
            this.selectedCompany = response.data;
            this.companyEntries.push(response.data);
          } else {
            this.selectedSourceCompany = response.data;
            this.sourceCompanyEntries.push(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    searchStakeholder: debounce(function fetchStakeHolders(field) {
      this.isLoadingCompany = field === 'company';
      this.isLoadingSourceCompany = field === 'source-company';

      // BASEURL
      let url = '/stakeholders?';

      // Name
      url += field === 'company' ? `name=${this.searchCompany}` : `name=${this.searchSourceCompany}`;

      // Page and Pagesize
      url += `&page=1&page-size=${this.pageSize}`;

      api.get(url)
        .then((response) => {
          if (field === 'company') {
            this.companyEntries = response.data;
            this.isLoadingCompany = false;
          } else {
            this.sourceCompanyEntries = response.data;
            this.isLoadingSourceCompany = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }, 300),
    searchInputs: debounce(function fetchInputs() {
      this.isLoadingReference = true;

      // BASEURL
      let url = '/inputs?';

      // stakeholder-ref
      url += `stakeholder-ref=${this.searchReference}`;

      // stakeholder
      if (this.selectedCompany != null) {
        url += `&stakeholder=${this.selectedCompany.id}`;
      }

      // Page and Pagesize
      url += `&page=1&page-size=${this.pageSize}`;

      api.get(url)
        .then((response) => {
          this.inputEntries = response.data;
          this.isLoadingReference = false;
        })
        .catch((error) => {
          console.log(error);
        });
    }, 300),
    changeReference(reference) {
      if (typeof reference === 'object' && reference !== null) {
        this.$eventHub.$emit('found-input-by-reference', reference);
      }
    },
    onInputFormSaved() {
      this.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            const generalDossierInfo = {
              type: this.type,
              reference: this.reference,
              selectedCompany: this.selectedCompany,
              sourceReference: this.sourceReference,
              selectedSourceCompany: this.selectedSourceCompany,
              source: this.source,
              cargoProductTypes: this.cargoProductTypes,
              jobDate: formatToIsoDate(this.jobDate),
            };

            this.$eventHub.$emit('fetch-general-dossier-info', generalDossierInfo);
          } else {
            this.$eventHub.$emit('fetch-general-dossier-info', null);
          }
        })
        .catch((error) => {
          console.log(error);
          console.log('something went wrong in file GeneralDossierInfo.controller.js method onInputFormSaved');
        });
    },
    removeCargoProductType(cargoProductType) {
      this.cargoProductTypes = this.cargoProductTypes.filter(cpt => cpt !== cargoProductType);
    },
  },
  watch: {
    inputForm() {
      if (this.inputForm != null) {
        this.type = this.inputForm.inputType;
        this.reference = this.inputForm.assigneeStakeholder != null ? this.inputForm.assigneeStakeholder.ref : '';

        if (this.inputForm.assigneeStakeholder != null) {
          this.setCompany('company', this.inputForm.assigneeStakeholder.id);
          this.reference = this.inputForm.assigneeStakeholder.reference;
        }

        if (this.inputForm.sourceStakeholder != null) {
          this.setCompany('source-company', this.inputForm.sourceStakeholder.id);
          this.sourceReference = this.inputForm.sourceStakeholder.reference;
        }

        this.source = this.inputForm.sourceType;
        this.cargoProductTypes = this.inputForm.cargoProductTypes;
        this.jobDate = formatToLocalDate(this.inputForm.jobDate);
      }
    },
    type() {
      this.$emit('on-input-form-type-changed', this.type);
    },
    searchCompany() {
      this.searchStakeholder('company');
    },
    searchSourceCompany() {
      this.searchStakeholder('source-company');
    },
    searchReference() {
      this.searchInputs();
    },
  },
  created() {
    this.$eventHub.$on('on-input-form-saved', this.onInputFormSaved);
  },
  mounted() {
    if (this.$route.query.type != null) {
      this.type = this.$route.query.type;
    }
  },
};
